// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
    background: rgba(0, 0, 0, .3);
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    text-align: left;
}

.message-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 350px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    font-size: 17px;
    padding: 25px;
    z-index: 10000;
    box-shadow: 1px 1px 4px 1px #656565;
    background-color: #fff;
    border-radius: 5px;
}

.message-modal-2 {
    padding-bottom: 25px;
}

.message-modal-btn {
    width: 100%;
    border: 1px solid #b1b1b1;
    background-color: #d5d5d5;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
}

.message-modal-btn:hover {
    background-color: #a3a2a2;
}


.customer-info {
    margin-top: 30%;
    background-color: #e8e2e2;
    border-radius: 7px;
    padding: 7px 0 7px 10px;
}

.customer-info>div {
    display: flex;
}

.cust-text {
    color: #73777b;
    font-weight: 600;
}

.cust-phone svg {
    color: #066163;
    width: 1rem;
    margin-left: 5px;
}

.cust-phone>span {
    margin-top: 2.5px;
    margin-left: 12px;
    font-weight: 500;
}

.cust-work>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-work {
    color: #0078aa;
    font-weight: 500;
    margin-right: 6px;
}

.cust-rest>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-rest {
    color: #bd574e;
    font-weight: 500;
    margin-right: 6px;
}

.header {
    /* position: fixed;
    top: 0;
    left: 0;
    z-index: 100; */
}

.section1 {
    display: flex;
}

.section2 {
    width: calc(100% - 12rem);
}

.section2.main {
    width: 100%;
}


.show_modal .modal-dialog {
    max-height: 98vh;
    overflow: auto;
}

.preview_wrap {
    overflow: auto;
    height: 83vh;
}

.customer-info {
    margin-top: 30%;
    background-color: #e8e2e2;
    border-radius: 7px;
    padding: 7px 0 7px 10px;
}

@media(max-width:1280px) {
    .section2 {
        width: calc(100% - 105px);
    }

    .customer-info {
        padding: 7px 0 7px 1.25rem;
    }
}

@media(max-width:768px) {
    .section2 {
        width: 100%;
    }
}


.customer-info>div {
    display: flex;
}

.cust-text {
    color: #73777b;
    font-weight: 600;
}

.cust-phone svg {
    color: #066163;
    width: 1rem;
    margin-left: 5px;
}

.cust-phone>span {
    margin-top: 2.5px;
    margin-left: 12px;
    font-weight: 500;
}

.cust-work>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-work {
    color: #0078aa;
    font-weight: 500;
    margin-right: 6px;
}

.cust-rest>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-rest {
    color: #bd574e;
    font-weight: 500;
    margin-right: 6px;
}

.litepicker .container__months .month-item-header .button-next-month>svg,
.litepicker .container__months .month-item-header .button-next-month>img {
    fill: transparent !important;
}

.litepicker .container__months .month-item-header .button-previous-month>svg,
.litepicker .container__months .month-item-header .button-previous-month>img {
    fill: transparent !important;
}

.tabBtn {
    width: 50%;
    text-align: center;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.tabBtn.active {
    background-color: #434242;
    color: #F6FBF4;
}

.pointer {
    cursor: pointer;
}

.pointer:hover {
    font-weight: 600;
}

.file_form {
    font-weight: 300;
    color: #8292a3;
    display: block;
    appearance: none;
    background-color: #fff;
    border-width: 1px;
    padding-top: 0.5rem;
    padding-right: 0.75rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
}
















.list-info-box .gap ul li {
    border-bottom: 1px solid #e1e1e1;
}

.list-info-box .gap ul li .inner {
    width: 50%;
    float: left;
}

.list-info-box .gap ul li .left-text {
    width: 35%;
    background: #f9f9f9;
    padding: 6px 6px;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.list-info-box .gap ul li .right-text {
    word-break: break-word;
    width: 65%;
    padding: 6px 6px;
    font-size: 12px;
    color: #646464;
    display: flex;
    align-items: center;
}

.list-info-box .gap ul li:after,
.list-info-box .gap ul li .inner:after {
    content: '';
    display: block;
    clear: both;
}


.main_logo {
    width: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 1280px) {
    .main_logo {
        width: 60px;
    }
}

.div-flex-2 {
    display: flex;
}

@media (max-width: 1450px) {
    .div-flex-2 {
        flex-direction: column;
        align-items: center;
    }
}

::-webkit-scrollbar {
    display: none;
}

.table-overflow-hidden {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block !important;
}

/* MobileListItem.css */
.mobile-ship-item {
    background: #fff;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    padding: 12px 12px 10px;
    margin: 10px 0;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.mobile-ship-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
}

.mobile-ship-date {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mobile-ship-date-pill {
    padding: 2px 8px;
    background: #f3f4f6;
    color: #6b7280;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.mobile-ship-time {
    font-size: 12px;
    color: #9ca3af;
}

.mobile-ship-head-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mobile-ship-badge {
    font-size: 11px;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 999px;
}

.mobile-ship-price {
    font-weight: 800;
    font-size: 15px;
}

.mobile-ship-body {
    display: grid;
    grid-template-columns: 72px 1fr;
    gap: 12px;
    align-items: center;
}

.mobile-ship-thumb {
    width: 72px;
    height: 72px;
    border-radius: 10px;
    overflow: hidden;
    background: #f3f4f6;
    display: grid;
    place-items: center;
}

.mobile-ship-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.mobile-ship-thumb-placeholder {
    color: #cbd5e1;
}

.mobile-ship-info {
    min-width: 0;
    display: grid;
    gap: 2px;
}

.mobile-ship-title {
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mobile-ship-code {
    color: #64748b;
    margin-right: 4px;
}

.mobile-ship-meta {
    font-size: 12px;
    color: #94a3b8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mobile-ship-addr {
    font-size: 12px;
    color: #6b7280;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 주소 2줄까지 */
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.mobile-ship-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.mobile-ship-btn {
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid #0ea5e9;
    background: #0ea5e9;
    color: #fff;
    font-weight: 800;
    font-size: 13px;
    cursor: pointer;
}

.mobile-ship-btn.is-done {
    border-color: #10b981;
    background: #10b981;
}

.mobile-ship-btn.is-primary {
    border-color: #0ea5e9;
    background: #0ea5e9;
}

.mobile-ship-btn:active {
    transform: translateY(1px);
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/main.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,cAAc;IACd,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;;;mBAGe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;AACzB;;;;;;;;;;;;;;;;;AAiBA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".error-modal {\r\n    background: rgba(0, 0, 0, .3);\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 9999;\r\n    display: flex;\r\n    text-align: left;\r\n}\r\n\r\n.message-modal {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    max-width: 350px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    font-size: 17px;\r\n    padding: 25px;\r\n    z-index: 10000;\r\n    box-shadow: 1px 1px 4px 1px #656565;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n}\r\n\r\n.message-modal-2 {\r\n    padding-bottom: 25px;\r\n}\r\n\r\n.message-modal-btn {\r\n    width: 100%;\r\n    border: 1px solid #b1b1b1;\r\n    background-color: #d5d5d5;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n\r\n.message-modal-btn:hover {\r\n    background-color: #a3a2a2;\r\n}\r\n\r\n\r\n.customer-info {\r\n    margin-top: 30%;\r\n    background-color: #e8e2e2;\r\n    border-radius: 7px;\r\n    padding: 7px 0 7px 10px;\r\n}\r\n\r\n.customer-info>div {\r\n    display: flex;\r\n}\r\n\r\n.cust-text {\r\n    color: #73777b;\r\n    font-weight: 600;\r\n}\r\n\r\n.cust-phone svg {\r\n    color: #066163;\r\n    width: 1rem;\r\n    margin-left: 5px;\r\n}\r\n\r\n.cust-phone>span {\r\n    margin-top: 2.5px;\r\n    margin-left: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n.cust-work>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-work {\r\n    color: #0078aa;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest {\r\n    color: #bd574e;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.header {\r\n    /* position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 100; */\r\n}\r\n\r\n.section1 {\r\n    display: flex;\r\n}\r\n\r\n.section2 {\r\n    width: calc(100% - 12rem);\r\n}\r\n\r\n.section2.main {\r\n    width: 100%;\r\n}\r\n\r\n\r\n.show_modal .modal-dialog {\r\n    max-height: 98vh;\r\n    overflow: auto;\r\n}\r\n\r\n.preview_wrap {\r\n    overflow: auto;\r\n    height: 83vh;\r\n}\r\n\r\n.customer-info {\r\n    margin-top: 30%;\r\n    background-color: #e8e2e2;\r\n    border-radius: 7px;\r\n    padding: 7px 0 7px 10px;\r\n}\r\n\r\n@media(max-width:1280px) {\r\n    .section2 {\r\n        width: calc(100% - 105px);\r\n    }\r\n\r\n    .customer-info {\r\n        padding: 7px 0 7px 1.25rem;\r\n    }\r\n}\r\n\r\n@media(max-width:768px) {\r\n    .section2 {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n\r\n.customer-info>div {\r\n    display: flex;\r\n}\r\n\r\n.cust-text {\r\n    color: #73777b;\r\n    font-weight: 600;\r\n}\r\n\r\n.cust-phone svg {\r\n    color: #066163;\r\n    width: 1rem;\r\n    margin-left: 5px;\r\n}\r\n\r\n.cust-phone>span {\r\n    margin-top: 2.5px;\r\n    margin-left: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n.cust-work>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-work {\r\n    color: #0078aa;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest {\r\n    color: #bd574e;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-next-month>svg,\r\n.litepicker .container__months .month-item-header .button-next-month>img {\r\n    fill: transparent !important;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-previous-month>svg,\r\n.litepicker .container__months .month-item-header .button-previous-month>img {\r\n    fill: transparent !important;\r\n}\r\n\r\n.tabBtn {\r\n    width: 50%;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.tabBtn.active {\r\n    background-color: #434242;\r\n    color: #F6FBF4;\r\n}\r\n\r\n.pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.pointer:hover {\r\n    font-weight: 600;\r\n}\r\n\r\n.file_form {\r\n    font-weight: 300;\r\n    color: #8292a3;\r\n    display: block;\r\n    appearance: none;\r\n    background-color: #fff;\r\n    border-width: 1px;\r\n    padding-top: 0.5rem;\r\n    padding-right: 0.75rem;\r\n    padding-bottom: 0.5rem;\r\n    padding-left: 0.75rem;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.list-info-box .gap ul li {\r\n    border-bottom: 1px solid #e1e1e1;\r\n}\r\n\r\n.list-info-box .gap ul li .inner {\r\n    width: 50%;\r\n    float: left;\r\n}\r\n\r\n.list-info-box .gap ul li .left-text {\r\n    width: 35%;\r\n    background: #f9f9f9;\r\n    padding: 6px 6px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.list-info-box .gap ul li .right-text {\r\n    word-break: break-word;\r\n    width: 65%;\r\n    padding: 6px 6px;\r\n    font-size: 12px;\r\n    color: #646464;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.list-info-box .gap ul li:after,\r\n.list-info-box .gap ul li .inner:after {\r\n    content: '';\r\n    display: block;\r\n    clear: both;\r\n}\r\n\r\n\r\n.main_logo {\r\n    width: 148px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n@media (max-width: 1280px) {\r\n    .main_logo {\r\n        width: 60px;\r\n    }\r\n}\r\n\r\n.div-flex-2 {\r\n    display: flex;\r\n}\r\n\r\n@media (max-width: 1450px) {\r\n    .div-flex-2 {\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.table-overflow-hidden {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block !important;\r\n}\r\n\r\n/* MobileListItem.css */\r\n.mobile-ship-item {\r\n    background: #fff;\r\n    border: 1px solid #f1f5f9;\r\n    border-radius: 12px;\r\n    padding: 12px 12px 10px;\r\n    margin: 10px 0;\r\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.mobile-ship-head {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 8px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.mobile-ship-date {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.mobile-ship-date-pill {\r\n    padding: 2px 8px;\r\n    background: #f3f4f6;\r\n    color: #6b7280;\r\n    border-radius: 999px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n}\r\n\r\n.mobile-ship-time {\r\n    font-size: 12px;\r\n    color: #9ca3af;\r\n}\r\n\r\n.mobile-ship-head-right {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.mobile-ship-badge {\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    padding: 4px 8px;\r\n    border-radius: 999px;\r\n}\r\n\r\n.mobile-ship-price {\r\n    font-weight: 800;\r\n    font-size: 15px;\r\n}\r\n\r\n.mobile-ship-body {\r\n    display: grid;\r\n    grid-template-columns: 72px 1fr;\r\n    gap: 12px;\r\n    align-items: center;\r\n}\r\n\r\n.mobile-ship-thumb {\r\n    width: 72px;\r\n    height: 72px;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    background: #f3f4f6;\r\n    display: grid;\r\n    place-items: center;\r\n}\r\n\r\n.mobile-ship-thumb img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.mobile-ship-thumb-placeholder {\r\n    color: #cbd5e1;\r\n}\r\n\r\n.mobile-ship-info {\r\n    min-width: 0;\r\n    display: grid;\r\n    gap: 2px;\r\n}\r\n\r\n.mobile-ship-title {\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.mobile-ship-code {\r\n    color: #64748b;\r\n    margin-right: 4px;\r\n}\r\n\r\n.mobile-ship-meta {\r\n    font-size: 12px;\r\n    color: #94a3b8;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.mobile-ship-addr {\r\n    font-size: 12px;\r\n    color: #6b7280;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    /* 주소 2줄까지 */\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n}\r\n\r\n.mobile-ship-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 12px;\r\n}\r\n\r\n.mobile-ship-btn {\r\n    height: 36px;\r\n    padding: 0 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid #0ea5e9;\r\n    background: #0ea5e9;\r\n    color: #fff;\r\n    font-weight: 800;\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n}\r\n\r\n.mobile-ship-btn.is-done {\r\n    border-color: #10b981;\r\n    background: #10b981;\r\n}\r\n\r\n.mobile-ship-btn.is-primary {\r\n    border-color: #0ea5e9;\r\n    background: #0ea5e9;\r\n}\r\n\r\n.mobile-ship-btn:active {\r\n    transform: translateY(1px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
